import Vector from "../../../../../Assets/Images/EmptyState.svg";
import "../../../../../Assets/Styles/EmptyState.scss";
import React from "react";

const FormEmptyState = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData?.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    if (Label) {
      return Label[0]?.label_value;
    }
  };

  return (
    <div className="empty-state-holder">
      <div className="empty-state">
        <img alt="" src={Vector} />
        {props.Message ? (
          <p>{props.Message}</p>
        ) : (
          <p>{translateText(`empty_${props.StateName}_recommendation`)}</p>
        )}
        {props.ActionButton || props.ActionButton === null ? (
          props.ActionButton
        ) : (
          <button onClick={() => props.ResetFilters()}>Reset Filters</button>
        )}
      </div>
    </div>
  );
};

export default FormEmptyState;
